import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import img from "@/assets/concorso-geometri.jpg";
import { Award, Calendar, GraduationCap } from "lucide-react";

const Concorsi = () => (
  <>
    <SEO
      title="Concorsi — I Futuri Geometri Progettano l'Accessibilità"
      description="Concorso Nazionale 'I Futuri Geometri Progettano l'Accessibilità', in collaborazione con CNGeGL. XIV edizione nel 2026 per gli Istituti CAT."
      path="/concorsi"
    />
    <PageHero
      eyebrow="Concorsi"
      title="I Futuri Geometri Progettano l'Accessibilità"
      subtitle="Da 13 anni un'iniziativa di sensibilizzazione e diffusione della cultura dell'accessibilità."
    />
    <section className="section-padding">
      <div className="container-narrow grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-5 leading-relaxed text-foreground/90">
          <p>FIABA, in collaborazione con il <strong>CNGeGL – Consiglio Nazionale Geometri e Geometri Laureati</strong>, porta avanti da 13 anni un'importante iniziativa di sensibilizzazione e diffusione della cultura dell'accessibilità: il Concorso Nazionale <em>"I Futuri Geometri Progettano l'Accessibilità"</em>.</p>
          <p>Nel 2026 si svolgerà la <strong>XIV edizione</strong> del Concorso.</p>
          <p>L'iniziativa è rivolta agli <strong>Istituti di Costruzione, Ambiente e Territorio (CAT)</strong> che, attraverso il lavoro dei propri studenti, progettano soluzioni accessibili su tutto il territorio nazionale, contribuendo alla formazione delle nuove generazioni di tecnici attenti ai temi dell'inclusione e della progettazione universale.</p>
          <div className="grid sm:grid-cols-3 gap-3 mt-8">
            {[
              { i: Award, n: "XIV", l: "Edizione 2026" },
              { i: Calendar, n: "13", l: "Anni di Concorso" },
              { i: GraduationCap, n: "Italia", l: "Istituti CAT coinvolti" },
            ].map((s) => (
              <div key={s.l} className="bg-muted p-4 rounded-lg text-center">
                <s.i className="w-7 h-7 text-secondary mx-auto mb-2" />
                <p className="font-serif text-2xl font-bold text-primary">{s.n}</p>
                <p className="text-xs text-muted-foreground">{s.l}</p>
              </div>
            ))}
          </div>
        </div>
        <img src={img} alt="Cerimonia di premiazione del concorso geometri" className="rounded-lg shadow-elegant" loading="lazy" />
      </div>
    </section>
  </>
);

export default Concorsi;
